import React from "react";

const DisassemblyReassembly = ({ onClose }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 px-4 py-6 font-instrument">
      <div className="relative w-full max-w-[500px]  bg-white rounded-2xl shadow-2xl overflow-hidden">
        <button
          onClick={onClose}
          aria-label="Close"
          className="absolute top-[13px] left-[13px] flex items-center justify-center z-10"
        >
          <img src="/Vision Agent Icons/X Icon/XLightpurple.svg" alt="Close Icon" className="w-5 h-5" />
        </button>

        <div className="flex flex-col md:flex-row items-center gap-6 p-6 md:p-8">
          <div className="flex-shrink-0 flex items-center justify-center md:ml-2">
            <div className="w-[125px] h-[125px] rounded-full bg-[#EAE8FF] flex items-center justify-center">
              <img
                src="/images/DisassemblyIcon2.svg"
                alt="tools icon"
                className="object-contain"
              />
            </div>
          </div>

          <div className="flex-1 text-left">
            <h2 className="text-[20px] md:text-[22px] font-semibold text-[#34318C]">
              Disassembly/Reassembly?
            </h2>

            <p className="mt-2 text-sm text-[#34318C] leading-4">
              Turn this on if any items need to be taken apart to move (or put
              back together after). Examples: bed frames, tables, shelving,
              desks.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DisassemblyReassembly;
